import React, { FC } from "react";
import { ToolbarProps } from "@mui/material";

import { StyledMuiToolbar } from "./styled";

export interface IStyledToolbarProps extends ToolbarProps {}

export const StyledToolbar: FC<IStyledToolbarProps> = props => {
  const { children, ...rest } = props;

  return (
    <StyledMuiToolbar {...rest} disableGutters>
      {children}
    </StyledMuiToolbar>
  );
};
